// import { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { FiDownload, FiMail, FiGithub, FiLinkedin, FiTwitter } from 'react-icons/fi';
// import { Helmet } from 'react-helmet-async';
// import api from '../utils/api';

// const About = () => {
//   const [skills, setSkills] = useState([]);
//   const [experiences, setExperiences] = useState([]);
//   const [resume, setResume] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [skillsRes, experiencesRes, resumeRes] = await Promise.all([
//           api.get('/api/skills'),
//           api.get('/api/experiences'),
//           api.get('/api/resumes/latest'),
//         ]);
//         setSkills(skillsRes.data.map(skill => ({
//           category: skill.title,
//           items: skill.skills,
//         })));
//         setExperiences(experiencesRes.data);
//         setResume(resumeRes.data);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setSkills([]);
//         setExperiences([]);
//         setResume(null);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <div className="loading-spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>About - Portfolio</title>
//         <meta name="description" content="Learn more about my background, skills, and experience as a software engineer" />
//       </Helmet>

//       <div className="pt-20 section-padding bg-dark-900">
//         <div className="container-custom">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <h1 className="text-4xl md:text-5xl font-bold text-center mb-12 text-white">
//               About Me
//             </h1>

//             <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
//               <div>
//                 <div className="rounded-2xl mb-6">
//                   <img
//                     src="https://i.postimg.cc/8CDpVMSj/for-portfolioupdate.jpg"
//                     alt="Profile"
//                     className="w-full h-auto rounded-3xl"
//                   />
//                 </div>
//               </div>

//               <div>
//                 <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white">
//                   Hi, I'm a Software Engineer
//                 </h2>
//                 <p className="text-lg mb-6 text-light-200">
//                   With over 5 years of experience in web development, I specialize in creating 
//                   modern, scalable applications using cutting-edge technologies. I'm passionate 
//                   about clean code, user experience, and continuous learning.
//                 </p>
//                 <p className="text-lg mb-6 text-light-200">
//                   I believe in writing code that is not only functional but also maintainable 
//                   and efficient. My approach combines technical expertise with creative 
//                   problem-solving to deliver solutions that exceed expectations.
//                 </p>

//                 <div className="flex flex-wrap gap-4 mb-8">
//                   <a
//                     href="/api/resumes/download"
//                     className="btn-primary inline-flex items-center"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     download={resume?.originalName || 'resume.pdf'}
//                   >
//                     <FiDownload className="mr-2" />
//                     Download Resume
//                   </a>
//                   <a
//                     href="mailto:osman@gmail.com"
//                     className="btn-secondary inline-flex items-center"
//                   >
//                     <FiMail className="mr-2" />
//                     Get In Touch
//                   </a>
//                 </div>

//                 <div className="flex gap-4">
//                   <a
//                     href="https://github.com/MrGranday"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="p-3 rounded-lg bg-dark-700 text-gray-600 dark:text-gray-300 hover:text-primary-500 transition-colors"
//                   >
//                     <FiGithub size={24} />
//                   </a>
//                   <a
//                     href="https://www.linkedin.com/in/osman-ghani-granday-368b18259/"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="p-3 rounded-lg bg-dark-700 text-gray-600 dark:text-gray-300 hover:text-primary-500 transition-colors"
//                   >
//                     <FiLinkedin size={24} />
//                   </a>
//                   <a
//                     href="https://x.com/OGranday"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="p-3 rounded-lg bg-dark-700 text-gray-600 dark:text-gray-300 hover:text-primary-500 transition-colors"
//                   >
//                     <FiTwitter size={24} />
//                   </a>
//                 </div>
//               </div>
//             </div>

//             {/* Skills Section */}
//             <section className="mb-16">
//               <h2 className="text-3xl font-bold text-center mb-12 text-white">Technical Skills</h2>
//               <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
//                 {skills.length === 0 ? (
//                   <p className="text-center col-span-4 text-gray-600 dark:text-gray-300">No skills available</p>
//                 ) : (
//                   skills.map((skillGroup, index) => (
//                     <motion.div
//                       key={skillGroup.category}
//                       className="card text-center"
//                       initial={{ opacity: 0, y: 30 }}
//                       whileInView={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5, delay: index * 0.1 }}
//                       viewport={{ once: true }}
//                     >
//                       <h3 className="text-xl font-bold mb-4 text-white">{skillGroup.category}</h3>
//                       <div className="space-y-2">
//                         {skillGroup.items.map((skill) => (
//                           <div
//                             key={skill}
//                             className="px-3 py-2 rounded-lg text-sm bg-dark-700 text-gray-700 dark:text-gray-300"
//                           >
//                             {skill}
//                           </div>
//                         ))}
//                       </div>
//                     </motion.div>
//                   ))
//                 )}
//               </div>
//             </section>

//             {/* Experience Section */}
//             <section>
//               <h2 className="text-3xl font-bold text-center mb-12 text-white">Experience</h2>
//               <div className="max-w-3xl mx-auto">
//                 {experiences.length === 0 ? (
//                   <p className="text-center text-gray-600 dark:text-gray-300">No experiences available</p>
//                 ) : (
//                   experiences.map((exp, index) => (
//                     <motion.div
//                       key={exp._id}
//                       className="card mb-8 relative"
//                       initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
//                       whileInView={{ opacity: 1, x: 0 }}
//                       transition={{ duration: 0.5, delay: index * 0.1 }}
//                       viewport={{ once: true }}
//                     >
//                       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
//                         <div>
//                           <h3 className="text-xl font-bold text-white">{exp.title}</h3>
//                           <p className="text-primary-500 font-medium">{exp.company}</p>
//                         </div>
//                         <span className="text-sm px-3 py-1 rounded-full bg-dark-700 text-gray-600 dark:text-gray-300">
//                           {exp.period}
//                         </span>
//                       </div>
//                       <p className="text-gray-600 dark:text-gray-300">{exp.description}</p>
//                     </motion.div>
//                   ))
//                 )}
//               </div>
//             </section>
//           </motion.div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default About;

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiDownload, FiMail, FiGithub, FiLinkedin, FiTwitter, FiCpu, FiBriefcase, FiAward } from 'react-icons/fi';
import { Helmet } from 'react-helmet-async';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../utils/api';

const About = () => {
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [skillsRes, experiencesRes, resumeRes] = await Promise.all([
          api.get('/api/skills'),
          api.get('/api/experiences'),
          api.get('/api/resumes/latest').catch(() => ({ data: null })),
        ]);
        setSkills(skillsRes.data.map(skill => ({
          category: skill.title,
          items: skill.skills,
        })));
        setExperiences(experiencesRes.data);
        setResume(resumeRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        setSkills([]);
        setExperiences([]);
        setResume(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleDownloadResume = async (e) => {
    e.preventDefault();
    if (!resume) {
      toast.error('No resume available for download');
      return;
    }

    try {
      const response = await api.get('/api/resumes/download', {
        responseType: 'blob', // Handle binary data
      });

      // Create a Blob URL and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', resume.originalName || 'resume.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success('Resume downloaded successfully');
    } catch (error) {
      console.error('Download resume error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to download resume';
      toast.error(errorMessage);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>About - Portfolio</title>
        <meta name="description" content="Learn more about my background, skills, and experience as a software engineer" />
      </Helmet>

      <div className="pt-20 section-padding bg-dark-900">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-12 text-white">
              About Me
            </h1>

            <div className="grid lg:grid-cols-2 gap-12 items-center mb-24">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
                className="relative group"
              >
                <div className="absolute -inset-1 bg-gradient-to-r from-secondary_accent to-accent rounded-[2rem] blur opacity-25 transition duration-1000 group-hover:duration-200"></div>
                <div className="relative rounded-[2rem] overflow-hidden border border-white/10 aspect-[4/5] sm:aspect-square lg:aspect-[4/5]">
                  <img
                    src="https://i.postimg.cc/8CDpVMSj/for-portfolioupdate.jpg"
                    alt="Profile"
                    className="w-full h-full object-cover transition-transform duration-700 "
                    //  group-hover:scale-110 group-hover:opacity-50
                  />
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white tracking-tight">
                  Hi, I'm <span className="text-secondary_accent">Osman Ghani</span>
                </h2>
                <p className="text-lg mb-6 text-gray-400 font-light leading-relaxed">
                  With over 5 years of experience in web development, I specialize in creating 
                  modern, scalable applications using cutting-edge technologies. I'm passionate 
                  about clean code, user experience, and continuous learning.
                </p>
                <p className="text-lg mb-8 text-gray-400 font-light leading-relaxed">
                  I believe in writing code that is not only functional but also maintainable 
                  and efficient. My approach combines technical expertise with creative 
                  problem-solving to deliver solutions that exceed expectations.
                </p>

                <div className="flex flex-wrap gap-4 mb-10">
                  <button
                    onClick={handleDownloadResume}
                    className={`btn-primary inline-flex items-center px-8 py-3 rounded-xl shadow-lg shadow-secondary_accent/20 ${!resume ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={!resume}
                  >
                    <FiDownload className="mr-2" />
                    Download CV
                  </button>
                  <a
                    href="mailto:osmangranday@gmail.com"
                    className="btn-secondary inline-flex items-center px-8 py-3 rounded-xl border-white/10 hover:border-secondary_accent transition-all duration-300"
                  >
                    <FiMail className="mr-2" />
                    Let's Talk
                  </a>
                </div>

                <div className="flex gap-4">
                  {[
                    { icon: <FiGithub size={20} />, href: "https://github.com/MrGranday" },
                    { icon: <FiLinkedin size={20} />, href: "https://www.linkedin.com/in/osman-ghani-granday-368b18259/" },
                    { icon: <FiTwitter size={20} />, href: "https://x.com/OGranday" }
                  ].map((social, i) => (
                    <motion.a
                      key={i}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-4 rounded-xl bg-white/5 border border-white/5 text-gray-400 hover:text-secondary_accent hover:border-secondary_accent/30 transition-all duration-300"
                      whileHover={{ y: -5, scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      {social.icon}
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </div>

            <section className="mb-16">
              <h2 className="text-3xl font-bold text-center mb-12 text-white">Technical Skills</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {skills.length === 0 ? (
                  <p className="text-center col-span-4 text-gray-600 dark:text-gray-300">No skills available</p>
                ) : (
                  skills.map((skillGroup, index) => (
                    <motion.div
                      key={skillGroup.category}
                      className="glass-effect rounded-2xl p-6 border border-white/5 dark:border-white/10 transition-all duration-500 hover:shadow-2xl hover:shadow-secondary_accent/5 hover:-translate-y-2 relative overflow-hidden group"
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      {/* Background Icon Decor */}
                      <div className="absolute -right-4 -bottom-4 opacity-[0.03] group-hover:opacity-[0.08] transition-all duration-500 group-hover:scale-110 group-hover:rotate-12 pointer-events-none">
                        <FiCpu size={100} />
                      </div>

                      <div className="relative z-10 text-center">
                        <h3 className="text-lg font-bold mb-5 text-white tracking-tight group-hover:text-secondary_accent transition-colors">{skillGroup.category}</h3>
                        <div className="flex flex-wrap gap-2 justify-center">
                          {skillGroup.items.map((skill) => (
                            <div
                              key={skill}
                              className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white/5 text-gray-400 border border-white/5 group-hover:border-secondary_accent/30 group-hover:text-white transition-all duration-300"
                            >
                              {skill}
                            </div>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  ))
                )}
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-center mb-12 text-white">Experience</h2>
              <div className="max-w-3xl mx-auto">
                {experiences.length === 0 ? (
                  <p className="text-center text-gray-600 dark:text-gray-300">No experiences available</p>
                ) : (
                  experiences.map((exp, index) => (
                    <motion.div
                      key={exp._id}
                      className="glass-effect rounded-2xl p-6 mb-8 border border-white/5 transition-all duration-500 hover:shadow-2xl hover:shadow-secondary_accent/5 relative overflow-hidden group"
                      initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      {/* Background Icon Decor */}
                      <div className="absolute -right-6 -bottom-6 opacity-[0.03] group-hover:opacity-[0.08] transition-all duration-500 group-hover:scale-125 group-hover:-rotate-12 pointer-events-none">
                        <FiBriefcase size={150} />
                      </div>

                      <div className="relative z-10">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
                          <div className="flex items-center gap-4">
                            <div className="p-3 rounded-xl bg-secondary_accent/10 text-secondary_accent">
                              <FiAward size={24} />
                            </div>
                            <div>
                              <h3 className="text-xl font-bold text-white group-hover:text-secondary_accent transition-colors">{exp.title}</h3>
                              <p className="text-secondary_accent/80 font-medium tracking-wide text-sm">{exp.company}</p>
                            </div>
                          </div>
                          <span className="mt-2 sm:mt-0 text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-full bg-white/5 text-gray-400 border border-white/5 group-hover:border-secondary_accent/30 group-hover:text-gray-200 transition-all duration-300">
                            {exp.period}
                          </span>
                        </div>
                        <div
                          className="text-gray-400 text-sm leading-relaxed font-light group-hover:text-gray-300 transition-colors prose-sm max-w-none"
                          dangerouslySetInnerHTML={{ __html: exp.description }}
                        />
                      </div>
                    </motion.div>
                  ))
                )}
              </div>
            </section>
          </motion.div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default About;